import { Identity, IdentityId } from '../types';

export const identities: Identity[] = [
  {
    id: 'executive',
    name: '初创高管',
    icon: '🏢',
    painPoint: '信息太多，决策太慢',
  },
  {
    id: 'sales',
    name: '销售精英',
    icon: '💼',
    painPoint: '客户资料散落各处，跟进总遗漏',
  },
  {
    id: 'insurance',
    name: '保险顾问',
    icon: '🛡️',
    painPoint: '专业服务很耗时，客户维护成本高',
  },
  {
    id: 'entrepreneur',
    name: '创业者',
    icon: '🚀',
    painPoint: '一个人干五个人的活，精力不够用',
  },
];

export const getIdentityById = (id: IdentityId): Identity | undefined =>
  identities.find((i) => i.id === id);
